import React, { useState, useEffect } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux'
import isEmpty from "lodash/isEmpty";
import { PAYMENT_FREQUENCIES } from '../constants/payment'
import {
    getCashPurchaseDeposit,
    getCashPurchaseOption,
    getCashPurchaseToPay,
    getIsCashSelected,
    getIsLeaseSelected,
    getIsFinanceSelected,
    getFinanceOptions,
    getMetaFinancePlans,
    getSelectedFinancePlan,
    getSelectedFinanceOptions,
    getHasTaxesIncluded,
    getPaymentOptions,
    getMoneyFormatter,
    getNumberFormat,
    getIntegerFormatter,
    getSelectedTab,
} from '../redux/selectors';
import {Creators as actions} from "../redux/actions";
import {getPaymentDetails} from "../redux/selectors/vehicle";
import { t, l } from 'react-i18nify';
import {getAprDetails} from "../redux/selectors/finance";
import GetTradeinEstimate from "./GetTradeinEstimate";

import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    accordionRoot: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
    },
    accordionSummaryRoot: {
        padding: '0',
    },
    accordionDetailsRoot: {
        flexDirection: 'column',
        padding: '0',
        '&>*': {
            marginBottom: '10px',
        },
    },
}));

const Price = ({ purchaseMethodOrder, bestDeal, extraDisclaimer }) => {
    const classes = useStyles();
    //SELECTORS
    const selectedTab = useSelector(getSelectedTab);
    const paymentOptions = useSelector(getPaymentOptions);
    const paymentDetails = useSelector(getPaymentDetails);
    const isCashPurchaseSelected = useSelector(getIsCashSelected);
    const isLeaseSelected = useSelector(getIsLeaseSelected);
    const isFinanceSelected = useSelector(getIsFinanceSelected);
    const financeOptions = useSelector(getFinanceOptions);
    const cashPurchaseOption = useSelector(getCashPurchaseOption);
    const cashPurchase = useSelector(state => state.quote ? state.quote.cashPurchase : null);
    const finance = useSelector(state => state.quote ? state.quote.finance : null);
    const selectedFinanceOptions = useSelector(getSelectedFinanceOptions);
    const aprDetails = useSelector(getAprDetails);
    const formatAsMoney = useSelector(getMoneyFormatter);
    const formatAsInteger = useSelector(getIntegerFormatter);

    const { transaction = [] } = cashPurchaseOption;
    const base = transaction.find(item => item.category === 'base') || {};
    const msrp = base?.items?.find(item => item.description === 'MSRP') || {};
    const taxes = transaction.find(item => item.category === 'tax') || {};
    const discount = transaction.find(item => item.category === 'discount') || {};
    const options = transaction.find(item => item.category === 'option') || {};
    const protections = transaction.find(item => item.category === 'protection') || {};
    const sellingPrice = transaction.find(item => item.category === 'total') || {};
    const rebate = transaction.find(item => item.category === 'rebate') || {};
    const toPay = transaction.find(item => item.category === 'toPay') || {};

    const { lien, tradeIn, vehicleCondition } = paymentOptions || {};

    //DISPATCH
    const dispatch = useDispatch();
    const selectPlan = index => dispatch(actions.selectPlan(index));
    const selectCashPlan = () => dispatch(actions.selectCashPlan());
    const selectTab = tab => dispatch(actions.updateSelectedTab(tab));

    const bestDealArray = bestDeal ? bestDeal.split("|") : [];
    const purchaseMethodOrderArray = purchaseMethodOrder ? purchaseMethodOrder.split(",") : ['cash', 'finance', 'lease'];

    const [financeIndex, setFinanceIndex] = useState(-1);
    const [leaseIndex, setLeaseIndex] = useState(-1);
    const [isFinanceAvailable, setIsFinanceAvailable] = useState(false);
    const [isLeaseAvailable, setIsLeaseAvailable] = useState(false);
    const [isRebateAvailable, setIsRebateAvailable] = useState('display-none');
    const [cashOrder, setCashOrder] = useState();
    const [financeOrder, setFinanceOrder] = useState();
    const [leaseOrder, setLeaseOrder] = useState();

    useEffect(() => {
        setIsRebateAvailable (rebate > 0 ? '' : 'display-none');
    }, [rebate])

    useEffect(() => {
        setFinanceIndex(financeOptions.findIndex(financeOption => financeOption.purchaseMethod === 'finance'));
        setLeaseIndex(financeOptions.findIndex(financeOption => financeOption.purchaseMethod === 'lease'));
    }, [financeOptions])

    useEffect(() => {
        setIsFinanceAvailable(financeIndex >= 0 ? financeOptions[financeIndex].isAvailable : false);
        setIsLeaseAvailable(leaseIndex >= 0 ? financeOptions[leaseIndex].isAvailable : false);
    }, [financeIndex, leaseIndex]);

    useEffect(() => {
        purchaseMethodOrderArray.forEach((item, index) => {
            if (item === 'cash') setCashOrder(index);
            if (item === 'finance') isFinanceAvailable ? setFinanceOrder(index) : setFinanceOrder(index + 3);
            if (item === 'lease') isLeaseAvailable ? setLeaseOrder(index) : setLeaseOrder(index + 3);
        })
    }, [isFinanceAvailable, isLeaseAvailable])

    useEffect(() => {
        const lowest = Math.min(cashOrder, financeOrder, leaseOrder);

        if (lowest === cashOrder) {
            selectTab('cash')
            selectCashPlan();
        }
        if (lowest === financeOrder) {
            selectTab('finance')
            selectPlan(financeIndex)
        }
        if (lowest === leaseOrder) {
            selectTab('lease')
            selectPlan(leaseIndex)
        }
    }, [cashOrder, financeOrder, leaseOrder]);

    const clickTab = item => {
        if (item === 'cash') selectCashPlan();
        if (item === 'finance') isFinanceAvailable && selectPlan(financeIndex);
        if (item === 'lease') isLeaseAvailable && selectPlan(leaseIndex);

        selectTab(item)
    }

    const Tabs = () => {
        return (
            <nav className="tabs vehicle-payment-tabs__title-wrapper" data-theme-style="vehiclePaymentTabs_borderColor">
                <div className={`tabs-title vehicle-payment-tabs__title ${selectedTab === 'cash' ? 'is-active' : ''}`} data-theme-style="vehiclePaymentTabs_item_fontColor" style={{ order: cashOrder }}>
                    <a onClick={() => clickTab('cash')}  className="tabs-title__anchor"  role="button" >
                        {t('purchaseMethod.cash')}
                    </a>
                </div>
                <div className={`tabs-title vehicle-payment-tabs__title ${selectedTab === 'finance' ? 'is-active' : ''}`} data-theme-style="vehiclePaymentTabs_item_fontColor" style={{ order: financeOrder }}>
                    <a role="button" onClick={() => clickTab('finance')} className="tabs-title__anchor" >
                        {t('purchaseMethod.finance')}
                    </a>
                </div>
                <div className={`tabs-title vehicle-payment-tabs__title ${selectedTab === 'lease' ? 'is-active' : ''}`} data-theme-style="vehiclePaymentTabs_item_fontColor" style={{ order: leaseOrder }}>
                    <a role="button" onClick={() => clickTab('lease')} className="tabs-title__anchor" >
                        {t('purchaseMethod.lease')}
                    </a>
                </div>
            </nav>
        )
    };

    const cashPurchaseForm = () => {
        return (
            <div className="tabs-panel vehicle-payment-tabs__content is-active">
                <div className="header-price-cash-purchase builded">
                    <div className="vehicle-cash-purchase-original-price">
                        <Accordion classes={{ root: classes.accordionRoot }}>
                            <AccordionSummary classes={{ root: classes.accordionSummaryRoot }} expandIcon={<ExpandMoreIcon/>} aria-controls="panel1a-content" id="panel1a-header">
                                <div className="vehicle-cash-purchase__row-full">
                                    <span className="vehicle-cash-purchase-original-price__label">{t('wasAt')}</span>
                                    <span className="vehicle-cash-purchase-original-price__value">{formatAsMoney(base.amount)}</span>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails classes={{ root: classes.accordionDetailsRoot }}>
                                {base.items && base.items.map(item => (
                                    <div className="vehicle-cash-purchase__row-short">
                                        <span>{(item.description == 'MSRP' || item.description == 'PDSF')  ? 'Available at' : item.description}</span>
                                        <span>{formatAsMoney(item.amount)}</span>
                                    </div>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    {discount.amount < 0 &&
                        <div className="vehicle-cash-purchase-discounts">
                            <Accordion classes={{root: classes.accordionRoot}}>
                                <AccordionSummary classes={{root: classes.accordionSummaryRoot}}
                                                  expandIcon={<ExpandMoreIcon/>} aria-controls="panel2a-content"
                                                  id="panel2a-header">
                                    <div className="vehicle-cash-purchase__row-full">
                                        <span className="vehicle-cash-purchase-discounts__label"
                                              data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{discount.name} ({t('beforeTax')})</span>
                                        <span className="vehicle-cash-purchase-discounts__value"
                                              data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{formatAsMoney(discount.amount)}</span>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails classes={{root: classes.accordionDetailsRoot}}>
                                    {discount.items && discount.items.map(item => (
                                        <div className="vehicle-cash-purchase__row-short">
                                            <span><i className="vehicle-cash-purchase-discounts__icon"
                                                     data-theme-style="vehicleCashPurchase_incentivesValue_fontColor"
                                                     data-theme-sprite="rebate"></i>{item.description}</span>
                                            <span
                                                data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{formatAsMoney(item.amount)}</span>
                                        </div>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    }
                    <div className="vehicle-cash-purchase-extras">
                        <div className="vehicle-cash-purchase__row-short">
                            <span>{options.name}</span>
                            <span>{formatAsMoney(Math.abs(options.amount))}</span>
                        </div>
                        <div className="vehicle-cash-purchase__row-short">
                            <span>{protections.name}</span>
                            <span>{formatAsMoney(Math.abs(protections.amount))}</span>
                        </div>
                    </div>
                    <div className="vehicle-cash-purchase-selling-price">
                        <div className="vehicle-cash-purchase__row-short">
                            <span className="vehicle-cash-purchase-selling-price__label">{sellingPrice.name}</span>
                            <div className="vehicle-cash-purchase-selling-price__value">
                                <span className="vehicle-cash-purchase-selling-price__value-amount">{formatAsMoney(sellingPrice.amount)}</span>
                                <p className="vehicle-cash-purchase-selling-price__value-smallprint" data-theme-style="smallprint">{cashPurchase.taxesDisclaimer}</p>
                            </div>
                        </div>
                    </div>
                    <div className="vehicle-cash-purchase-tradeinEstimate">
                        <div className="vehicle-cash-purchase__row-short">
                            <span className="vehicle-cash-purchase-tradeinEstimate__label">{t('tradeInLabel')}</span>
                            <div className="vehicle-cash-purchase-tradeinEstimate__details">
                                <div className="vehicle-cash-purchase-tradeinEstimate__value">
                                    <span className="vehicle-cash-purchase-tradeinEstimate__value-label">{t('tradeInLabel')}</span>
                                    <span className="vehicle-cash-purchase-tradeinEstimate__value-amount">{formatAsMoney(tradeIn)}</span>
                                </div>
                                <div className="vehicle-cash-purchase-owing">
                                    <span className="vehicle-cash-purchase-owing__value-label">{t('lienLabel')}</span>
                                    <span className="vehicle-cash-purchase-owing__value-amount">{formatAsMoney(lien)}</span>
                                </div>
                                <a className="vehicle-cash-purchase-tradeinEstimate__value-link" href="#tradein-widget" data-close="">{t('getTradeinEstimated')}</a>
                            </div>
                        </div>
                    </div>
                    <div className="vehicle-cash-purchase-taxes">
                        <Accordion classes={{ root: classes.accordionRoot }}>
                            <AccordionSummary classes={{ root: classes.accordionSummaryRoot }} expandIcon={<ExpandMoreIcon/>} aria-controls="panel3a-content" id="panel3a-header">
                                <div className="vehicle-cash-purchase__row-full">
                                    <span className="vehicle-cash-purchase-taxes__label">{taxes.name}</span>
                                    <span className="vehicle-cash-purchase-taxes__value">{formatAsMoney(taxes.amount)}</span>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails classes={{ root: classes.accordionDetailsRoot }}>
                                {taxes.items && taxes.items.map(item => (
                                    <div className="vehicle-cash-purchase__row-short">
                                        <span>{item.description}</span>
                                        <span>{formatAsMoney(item.amount)}</span>
                                    </div>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    <div className={`vehicle-cash-purchase-rebates ${isRebateAvailable}`}>
                            <Accordion classes={{ root: classes.accordionRoot }}>
                                <AccordionSummary classes={{ root: classes.accordionSummaryRoot }} expandIcon={<ExpandMoreIcon/>} aria-controls="panel4a-content" id="panel4a-header">
                                    <div className="vehicle-cash-purchase__row-full vehicle-cash-purchase__general-bold">
                                        <span data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{rebate.name} ({t('afterTax')})</span>
                                        <span data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{formatAsMoney(rebate.amount)}</span>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails classes={{ root: classes.accordionDetailsRoot }}>
                                    {rebate.items && rebate.items.map(item => (
                                        <div className="vehicle-cash-purchase__row-short">
                                            <span><i className="vehicle-cash-purchase-rebates__icon" data-theme-style="vehicleCashPurchase_incentivesValue_fontColor" data-theme-sprite="rebate"></i>{item.description}</span>
                                            <span data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{formatAsMoney(item.amount)}</span>
                                        </div>
                                    ))}
                                </AccordionDetails>
                            </Accordion> :
                            <div className="vehicle-cash-purchase__row-short vehicle-cash-purchase__general-bold no-content">
                                <span data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{rebate.name} ({t('afterTax')})</span>
                                <span data-theme-style="vehicleCashPurchase_incentivesValue_fontColor">{formatAsMoney(rebate.amount)}</span>
                            </div>
                    </div>
                    <div className="vehicle-cash-purchase__section vehicle-cash-purchase-total">
                        <div className="vehicle-cash-purchase__row-short">
                            <span className="vehicle-cash-purchase-total__label">{toPay.name}</span>
                            <span className="vehicle-cash-purchase-total__value">{formatAsMoney(toPay.amount)}</span>
                        </div>
                    </div>
                    <div className="vehicle-cash-purchase-legal">{t('legalText')}</div>
                </div>
            </div>
        )
    };

    const leaseFinanceForm = () => {
        const _term = `<span class="vehicle-finance__item-value-term" data-theme-style="vehicleFinance_termPayment_fontColor">${t('financeTermMonth', {termMonths: selectedFinanceOptions.selectedTerm})}</span>`;
        const _apr = `<span class="vehicle-finance__item-value-apr" data-theme-style="vehicleFinance_termPayment_fontColor">${selectedFinanceOptions.selectedApr}%</span>`;
        const _kmplan = `<span class="vehicle-finance__item-value-kmplan" data-theme-style="vehicleFinance_termPayment_fontColor">${formatAsInteger(selectedFinanceOptions.kmPerYearPlan)} km</span>`;
        const _cashdown = `<span class="vehicle-finance__item-value-cashdown" data-theme-style="vehicleFinance_termPayment_fontColor">${formatAsMoney(selectedFinanceOptions.selectedCashDown)}</span>`;
        const _tradein = `<span class="vehicle-finance__item-value-tradein" data-theme-style="vehicleFinance_termPayment_fontColor">${formatAsMoney(finance.tradeIn)}</span>`;
        const _lien = `<span class="vehicle-finance__item-value-lien" data-theme-style="vehicleFinance_termPayment_fontColor">${formatAsMoney(finance.lien)}</span>`;
        const financeTermCashdown = t('financeTerm', {apr: _apr, term: _term, cashdown: _cashdown, tradein: _tradein, lien: _lien});
        const leaseTermCashdown = t('leaseTerm', {term: _term, apr: _apr, cashdown: _cashdown, kmplan: _kmplan, tradein: _tradein, lien: _lien});
        const termAprCashdown = isLeaseSelected ? leaseTermCashdown : financeTermCashdown;
        const _totalCostCredit = `<span class="vehicle-finance-total-cost-credits__item-value">${formatAsMoney(aprDetails.totalCreditCost)}</span>`;
        const totalCostCreditMsg = t('totalCredit',{totalCostCredit: _totalCostCredit});

        const { paymentFrequency, selectedPayment } = selectedFinanceOptions;
        return (
            <div className="tabs-panel vehicle-payment-tabs__content is-active">
                <div className="header-price-finance builded">
                    <div className="vehicle-finance">
                        <div className="vehicle-finance__item">
                            <p className="vehicle-finance__item-term-payment ">
                                <p className="vehicle-finance__item-title">{t('availableAt')}</p>
                                <span className="vehicle-finance__item-term-payment-value" data-theme-style="vehicleFinance_termPayment_fontColor">
                                    {formatAsMoney(selectedPayment.payment)}*
                                </span>
                                <span className="vehicle-finance__item-payment-frequency-label" data-theme-style="vehicleFinance_paymentFrequency_fontColor">
                                    {'/'}{t(`paymentFrequency.${paymentFrequency}`)}
                                </span>
                            </p>
                            <p className="vehicle-finance__item-value " data-theme-style="vehicleFinance_term_fontColor" dangerouslySetInnerHTML={{ __html: termAprCashdown }}/>
                        </div>
                        <div className="vehicle-finance__tradein-details">
                           <GetTradeinEstimate />
                        </div>
                    </div>

                    <div className="vehicle-finance-disclaimer" data-theme-style="smallprint">
                        <p className="vehicle-finance-disclaimer__item">{finance.taxesDisclaimer}</p>
                    </div>
                    <div className="vehicle-finance__item">
                        <p className="vehicle-finance__item-value-price">{isFinanceSelected ? t('financePrice') : t('leasePrice')}</p>
                        <p className="vehicle-finance__item-term-payment-value" data-theme-style="vehicleFinance_termPayment_fontColor">{formatAsMoney(selectedFinanceOptions.sellingPrice)}</p>
                    </div>
                </div>
            </div>
        )
    };

    const disclaimerModal = () => {
        return(
            <>
                <div className="vehicle-disclaimer-popup">
                    <i role="none" data-theme-sprite="info" data-theme-style="vehicle_disclaimerIcon_fontColor"> </i>
                    <span className="vehicle-disclaimer-popup__item smallprint" data-theme-style="smallprint"
                          data-open="vehicleDisclaimer" aria-controls="vehicleDisclaimer" aria-haspopup="true"
                          tabIndex="0">
                        {'* '}{t('offerDetails')}
                    </span>
                </div>

                <div className="reveal-overlay">
                    <div className="reveal reveal-popup-alpha " id="vehicleDisclaimer" data-reveal="" role="dialog" aria-hidden="true" data-yeti-box="vehicleDisclaimer" data-resize="vehicleDisclaimer" data-e="gu5woo-e">
                        <button className="close-button reveal-popup-alpha__close-button" data-close="" aria-label="Close Accessible Modal" type="button">
                            <span aria-hidden="true">×</span>
                        </button>

                        {paymentOptions.disclaimer}
                        { extraDisclaimer && <div className='vehicle__fine-print-extra-disclaimer' dangerouslySetInnerHTML={{__html: extraDisclaimer}}></div> }
                    </div>
                </div>
            </>
        )
    }

    const notAvailable = () => {
        const notAvailableText = selectedTab === 'finance' ? (
            vehicleCondition.includes('used') ? t('financeNotAvailableUsed') : t('financeNotAvailable')
        ) : (
            vehicleCondition.includes('used') ? t('leaseNotAvailableUsed') : t('leaseNotAvailable')
        );

        return (
            <div className="vehicle-payment-option--not-available">
                {notAvailableText}
            </div>
        )
    }

    const getBestDeal = () => {
        if(!bestDealArray[0]) return;
        return `${t('bestDealLabel')} ${bestDealArray[0]} ${bestDealArray[1]}`;
    }

    return (
        <div className="tabs-bravo vehicle-payment-tabs catalog-details__vehicle-payment-tabs">
            <Tabs />
            <div className="tabs-content vehicle-payment-tabs__content-wrapper">
                {selectedTab === 'cash' && isCashPurchaseSelected && cashPurchaseForm()}
                {(!isEmpty(selectedFinanceOptions) && ((selectedTab === 'finance' && isFinanceSelected) || (selectedTab === 'lease' && isLeaseSelected))) && leaseFinanceForm()}
                {((selectedTab === 'finance' && !isFinanceSelected) || (selectedTab === 'lease' && !isLeaseSelected)) && notAvailable()}
            </div>

            { disclaimerModal() }
            { getBestDeal() }
        </div>
    )
};

export default Price;
